<script setup>

</script>

<template>
  <div class="landscape-mode">
    <div id="main_contain">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
@media screen and (orientation: portrait) {
  .landscape-mode {
    height: 100vw;
    width: 94vh;
    transform: rotate(90deg);
    transform-origin: 0 0;
    top: 0;
    left: 100%;
    position: absolute;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  #main_contain {
    width: 168vw;
    height: 94vw;
    display: flex;
    align-items: center;
    align-self: center;
    justify-items: center;
    align-content: center;
    justify-content: center;
  }
}

@media screen and (orientation: landscape) {
  .landscape-mode {
    width: 100%;
    height: 100%;
  }
}

</style>
